export default __webpack_public_path__ + "static/media/google.6d9ed119.png";